// import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;

import tippy from 'tippy.js';
// import 'tippy.js/dist/tippy.css';

require('webpack-jquery-ui');
// require('webpack-jquery-ui/css');

// require('tinymce');
// require('tinymce/themes/silver/theme');

// require('./js/helpers');
require('./js/project');
require('./js/application');
require('./js/comments');
require('./js/tooltips');

import Helpers from "./js/helpers_mod";

$(document).ready(function () {
    let helpers = new Helpers();
});

// helper.init();

// const queryString = window.location.search;
// const urlParams = new URLSearchParams(queryString);
// console.log(urlParams.has('product'));
